import { convertDateToYYYYMMDDFormat } from '@repo/ui';

type Period = {
  startDate: string | Date | null;
  endDate: string | Date | null;
};

export const normalizePeriod = (period: Period | null) => {
  if (!period) {
    return null;
  }

  const normalizedStartDate =
    period.startDate instanceof Date
      ? convertDateToYYYYMMDDFormat(period.startDate)
      : period.startDate || null;
  const normalizedEndDate =
    period.endDate instanceof Date
      ? convertDateToYYYYMMDDFormat(period.endDate)
      : period.endDate || null;

  if (!normalizedStartDate && !normalizedEndDate) {
    return null;
  }

  return {
    startDate: normalizedStartDate,
    endDate: normalizedEndDate,
  };
};
